import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebase/firebase-utils";

export default async function deleteNote(note) {
    try {
        const docRef = doc(db, "notes", note.id);
        await deleteDoc(docRef);
        console.log("Note deleted in Firebase");
    } catch (error) {
        console.log(error);
    }
}
